module.exports = __webpack_public_path__ + "static/media/innovation.91ae5e03.png";